import * as React from "react";
import { IIconProps } from "./Icon";

const Icon = (props: IIconProps) => (
  <svg
    width={props.width}
    style={props.style}
    height={props.width}
    viewBox="-57 0 512 512.001"
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${props.className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path d="m230.699219 89.164062h-223.179688v415.316407h300.835938v-337.660157zm0 0" fill="#e5ebf5"/>
    <path d="m7.519531 89.164062h30.085938v415.316407h-30.085938zm0 0" fill="#cad8ea"/>
    <path d="m312.339844 7.519531h-223.175782v81.644531h141.535157l77.65625 77.65625v256.015626h81.640625v-337.660157zm0 0" fill="#cad8ea"/>
    <path d="m260.78125 89.164062h-30.082031l77.65625 77.65625v256.015626h30.082031v-256.015626zm0 0" fill="#b0c4e0"/>
    <path d="m89.164062 7.519531h30.082032v81.644531h-30.082032zm0 0" fill="#b0c4e0"/>
    <path d="m230.699219 166.820312h77.65625l-77.65625-77.65625zm0 0" fill="#cad8ea"/>
    <path d="m312.339844 85.175781h77.65625l-77.65625-77.65625zm0 0" fill="#b0c4e0"/>
    <path d="m177.992188 126.769531h-15.039063v-15.042969h15.039063zm-25.070313 0h-15.039063v-15.042969h15.039063zm0 0" fill="#fff"/>
    <path d="m223.179688 119.246094v55.09375h55.089843v-15.042969h-40.050781v-40.050781zm0 0"/>
    <path d="m0 81.644531v430.355469h315.875v-348.296875l-82.058594-82.058594zm300.832031 415.3125h-285.789062v-400.273437h212.539062l73.25 73.25zm0 0"/>
    <path d="m57.660156 181.742188h116.988282v15.039062h-116.988282zm0 0"/>
    <path d="m82.730469 231.878906h175.484375v15.042969h-175.484375zm0 0"/>
    <path d="m57.660156 269.523438h200.554688v15.042968h-200.554688zm0 0"/>
    <path d="m57.660156 307.167969h175.484375v15.042969h-175.484375zm0 0"/>
    <path d="m82.730469 344.8125h175.484375v15.042969h-175.484375zm0 0"/>
    <path d="m57.660156 382.457031h200.554688v15.042969h-200.554688zm0 0"/>
    <path d="m57.660156 420.101562h175.484375v15.042969h-175.484375zm0 0"/>
    <path d="m304.820312 37.605469v55.089843h55.09375v-15.039062h-40.050781v-40.050781zm0 0"/>
    <path d="m315.457031 0h-233.8125v61.085938h15.039063v-46.042969h212.542968l73.25 73.25v327.023437h-46.046874v15.042969h61.089843v-348.296875zm0 0"/>
  </svg>  
);

export default Icon;
